module.exports = __webpack_public_path__ + "img/5.7589a510.png";